import React, { useEffect, useState } from "react";
import { getPaymentApi, getTxnBrreakDownApi, getAllPaymentModesApi, getAllPaymentChannelApi, SaveBulkVerifyPaymentApi, getDownlaodPaymentReportByVerififedStatus, getPaymentsMarkeRefundedinUnverifiedPayments } from "../AdminActionCreator.component";
import Pagination from '@mui/material/Pagination';
import Loader from '../../../presentationals/Loader/Loader.component';
import NodataImage from '../../../../images/nodata.png';
import moment from "moment";
import EmiBreakUp from "./breakdownpopup";
import PopUp from "../../../presentationals/Popup/Popup.component";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const Allpayments = ({ admin, payload, handlePayload }) => {
    const [visible, setVisible] = useState("overall")
    const [startDate, setStartDate] = useState(payload?.startDate);
    const [endDate, setEndDate] = useState(payload?.endDate);
    const [applicationId, setApplicationId] = useState('');
    const [processType, setProcessType] = useState('');
    const [mode, setMode] = useState('');
    const [objectData, setObjectData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(20);
    const [loaderState, setLoader] = useState(false);
    const [payData, setpayData] = useState('');
    const [showData, setshowData] = useState('');
    const [leadData, setLeadData] = useState('');
    const [popupStatus, setpopupStatus] = useState('No Data Found!');
    const [popupState, setpopupState] = useState(false);
    const [countData, setCounts] = useState('');
    const [filterDataDsec, setfilterDataDsec] = useState(false);
    const [APIData, setAPIData] = useState({})
    const [channelData, setChannelData] = useState([])
    const [modeData, setModeData] = useState([])
    const [selectedItems, setSelectedItems] = useState([]);
    const [newValues, setNewValues] = useState([]);

    useEffect(() => {
            const data = {
                startDate: startDate ?? "",
                endDate: endDate ?? "",
            }
            handlePayload(data)
        }, [startDate, endDate])
        
    const detailspayment = (data) => {
        console.log(data)
        setLeadData(data)
        setLoader(true)
        getTxnBrreakDownApi(data?.payments?.providerTransId, data?.payments?.loanId, callback => {
            if (callback && callback?.message == "success" && callback?.status == 200) {
                console.log(callback)
                setpayData(callback?.data)
                setshowData(true)
                setLoader(false)
            } else {
                setpopupState(true)
                setLoader(false)
                removePopup()

            }
        })
    }
    const removePopup = () => {
        setTimeout(() => {
            setpopupState(false)
        }, 5000);
    }
    const closePopup = () => {
        setshowData(false)
        setpopupState(false)
    }

    useEffect(() => {
        getAllPaymentModesApi((callback) => {
            console.log("callback", callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                setModeData(callback?.data)
            } else {
                setModeData([])
            }
        })
        getAllPaymentChannelApi((callback) => {
            console.log("callback", callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                setChannelData(callback?.data)
            } else {
                setChannelData([])
            }
        })
    }, [])

    useEffect(() => {

        getPaymentFuntion('', '',visible)

    }, [startDate, endDate]);

    const getPaymentFuntion = (channelValue, modeValue,type) => {
        setLoader(true);
        getPaymentApi(startDate !== '' ? moment(startDate).format('DD-MM-YYYY') : '', endDate !== '' ? moment(endDate).format('DD-MM-YYYY') : "", false, channelValue, modeValue,type, callback => {
            console.log(callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                setAPIData(callback?.data)
                setCounts(callback?.data?.paymentBreakupStatsPO);
                handleAPIValues(callback?.data, filterDataDsec)

            } else {
                setCounts('');
                setObjectData([]);
                setFilteredData([])
                setAPIData({})
                setObjectData([]);
                setFilteredData([])
            }

            setLoader(false);
        });
    }

    const handleAPIValues = (data, filterValue) => {
        if (filterValue == true) {
            const sortedData = [];
            const dataList = data?.paymentBreakUpDetailsPOAscList;

            if (dataList) {
                for (let i = dataList.length - 1; i >= 0; i--) {
                    sortedData.push(dataList[i]);
                }
            }

            setObjectData(sortedData);
            setFilteredData(sortedData);

        } else {
            setObjectData(data?.paymentBreakUpDetailsPOAscList);
            setFilteredData(data?.paymentBreakUpDetailsPOAscList);
        }
    }

    useEffect(() => {
        const data = objectData && objectData?.length > 0 ? objectData?.filter(payment =>
            (applicationId ? payment.applicationId && payment.applicationId.includes(applicationId) : true)
            // &&
            // (processType ? payment?.payments?.addedBy && payment?.payments?.addedBy.includes(processType) : true) &&
            // (mode ? payment?.payments?.pymntMode && payment?.payments?.pymntMode.includes(mode) : true)
        ) : [];
        setFilteredData(data);
        setCurrentPage(1);
    }, [applicationId, objectData]);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData && filteredData?.length > 0 ? filteredData?.slice(indexOfFirstItem, indexOfLastItem) : [];

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        setSelectedItems([])
        setNewValues([]);
    };
    const uniqueStatuses = objectData !== '' ? Array.from(new Set(objectData?.map(status => status?.payments?.pymntMode))) : ""
    const processUnique = objectData !== '' ? Array.from(new Set(objectData?.map(status => status?.payments?.addedBy))) : ""

    const handleAsecFilter = (value) => {
        setfilterDataDsec(value)
        handleAPIValues(APIData, value)

    }

    const handleChannelMode = (value, type) => {
        if (type === "channel") {
            setProcessType(value)
            getPaymentFuntion(value, mode,visible)
        } else if (type === "mode") {
            setMode(value)
            getPaymentFuntion(processType, value,visible)
        }
    }

    const handleCheckbox = (e, data) => {
        const isChecked = e.target.checked;
        const id = data?.paymentBreakUpDetailsDO?.id;

        if (isChecked) {
            setSelectedItems((prev) => [...prev, id]);
            setNewValues((prev) => [...prev, data?.paymentBreakUpDetailsDO])
        } else {
            setSelectedItems((prev) => prev.filter((itemId) => itemId !== id));
            setNewValues((prev) =>
                prev.filter(
                    (item) => item?.id !== data?.paymentBreakUpDetailsDO?.id
                )
            );
        }
    }



    const handleSelectAll = (event) => {
        const isChecked = event.target.checked;
        if (isChecked) {
            const allVisibleIds = currentItems.map((data) => data?.paymentBreakUpDetailsDO?.id);
            const allVisibleObjects = currentItems.map((data) => data?.paymentBreakUpDetailsDO);
            setSelectedItems(allVisibleIds);
            setNewValues(allVisibleObjects);
        } else {
            setSelectedItems([])
            setNewValues([]);
        }
    };



    const handleVerifyPayments = () => {
        setLoader(true)
        SaveBulkVerifyPaymentApi(admin.emailId, newValues, (callback) => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                setpopupState(true)
                setpopupStatus("Data Verified Successfully")
            } else {
                setpopupState(true)
                setpopupStatus("Error: Please Try Again later!")
            }
        })
    }


    const handleDownload = () => {
        setLoader(true)
        getDownlaodPaymentReportByVerififedStatus(moment(startDate).format('DD-MM-YYYY'), moment(endDate).format('DD-MM-YYYY'), processType, mode, (callback) => {
            setLoader(false)
            console.log("call", callback)
        })
    }

    const handleRefundCheckbox = (e, data) => {
        console.log("d", data)
        setLoader(true)
        getPaymentsMarkeRefundedinUnverifiedPayments(data?.payments?.loanId, data?.payments?.providerTransId, callback => {
            setLoader(false)
            console.log("call", callback)
            getPaymentFuntion("", "")
            if (callback == "Payment marked as refunded successfully.") {
                setpopupState(true)
                setpopupStatus("Status Marked Succefully")
            } else {
                setpopupState(true)
                setpopupStatus("Error Marking Status")
            }
            setTimeout(() => {
                closePopup()
            }, 5000)
        })
    }
     const handleView = (type) => {
        setVisible(type)
        getPaymentFuntion(processType, mode, type)
    }
    return (
        <div className="container-fluid">
            {showData ?
                <EmiBreakUp leadData={leadData} payData={payData} close={closePopup} admin={admin} editable={true} />
                : ""}
            {popupState ?
                <PopUp closePopup={closePopup} popupStatus={popupStatus} /> : ""}
            {console.log(processType)}
            {loaderState ? <Loader /> : ""}
            <h3><b>Unverified Payments</b></h3>

            <div className="row" style={{ marginTop: '20px' }}>
                <div className="col-sm-2 col-xs-12">
                    <label>Start Date </label>
                    <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </div>
                <div className="col-sm-2 col-xs-12">
                    <label>End Date: </label>
                    <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
                <div className="col-sm-2 col-xs-12">
                    <label>Application Id</label>
                    <input
                        type="text"
                        className="form-control"
                        value={applicationId}
                        onChange={(e) => setApplicationId(e.target.value)}
                    />
                </div>
                <div className="col-sm-2 col-xs-12">
                    <label>Channel </label>
                    {/* <input
                        type="text"
                        className="form-control"
                        value={processType}
                        onChange={(e) => setProcessType(e.target.value)}
                    /> */}
                    <select value={processType}
                        onChange={(e) => handleChannelMode(e.target.value, "channel")} className="form-control" >
                        <option value=''>All</option>
                        {channelData && channelData?.length > 0 ? channelData?.map((process, i) => (
                            <option key={i} value={process}>{process}</option>
                        )) : ''}
                    </select>
                </div>
                <div className="col-sm-2 col-xs-12">
                    <label>Mode</label>
                    <select value={mode}
                        onChange={(e) => handleChannelMode(e.target.value, "mode")} className="form-control" >
                        <option value=''>All</option>
                        {modeData && modeData?.length > 0 ? modeData?.map((mode, i) => (
                            <option key={i} value={mode}>{mode}</option>
                        )) : ''}
                    </select>
                    {/* <input
                        type="text"
                        className="form-control"
                        value={mode}
                        onChange={(e) => setMode(e.target.value)}
                    /> */}

                </div>
                {
                    (filteredData && filteredData?.length > 0) ?
                        <div className="col-sm-2 col-xs-12">
                            <button className="btn btn-primary" style={{ marginTop: '22px', padding: '11px 10px' }} onClick={() => handleDownload()}><DownloadIcon style={{ margin: '5px 0 -5px 0' }} /> &nbsp;Download Report</button>
                        </div>
                        : ''}
            </div>
            {countData && (
                <>
                    {/* <div className='row'>
                        <div className='col-sm-2 col-xs-12'>
                            <div className='shadow-card' style={{ marginTop: '30px', fontWeight: '700', minHeight: '100px' }}>
                                Total Amount <br />
                                <h4 style={{ color: 'grey', fontWeight: '700' }}>
                                    <i className='fa fa-rupee'></i>&nbsp;
                                    {Number(countData.total_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </h4>
                            </div>
                        </div>
                        <div className='col-sm-2 col-xs-12'>
                            <div className='shadow-card' style={{ marginTop: '30px', fontWeight: '700', minHeight: '100px' }}>
                                Principal Amount <br />
                                <h4 style={{ color: 'grey', fontWeight: '700' }}>
                                    <i className='fa fa-rupee'></i>&nbsp;
                                    {Number(countData.total_principal || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </h4>
                            </div>
                        </div>
                        <div className='col-sm-2 col-xs-12'>
                            <div className='shadow-card' style={{ marginTop: '30px', fontWeight: '700', minHeight: '100px' }}>
                                Interest Amount <br />
                                <h4 style={{ color: 'grey', fontWeight: '700' }}>
                                    <i className='fa fa-rupee'></i>&nbsp;
                                    {Number(countData.total_interest || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </h4>
                            </div>
                        </div>
                        <div className='col-sm-2 col-xs-12'>
                            <div className='shadow-card' style={{ marginTop: '30px', fontWeight: '700', minHeight: '100px' }}>
                                Penalty Amount <br />
                                <h4 style={{ color: 'grey', fontWeight: '700' }}>
                                    <i className='fa fa-rupee'></i>&nbsp;
                                    {Number(countData.total_penalty || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </h4>
                            </div>
                        </div>
                        <div className='col-sm-2 col-xs-12'>
                            <div className='shadow-card' style={{ marginTop: '30px', fontWeight: '700', minHeight: '100px' }}>
                                Penalty GST <br />
                                <h4 style={{ color: 'grey', fontWeight: '700' }}>
                                    <i className='fa fa-rupee'></i>&nbsp;
                                    {Number(countData.total_penaltyGst || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </h4>
                            </div>
                        </div>
                        <div className='col-sm-2 col-xs-12'>
                            <div className='shadow-card' style={{ marginTop: '30px', fontWeight: '700', minHeight: '100px' }}>
                                Bounce Amount <br />
                                <h4 style={{ color: 'grey', fontWeight: '700' }}>
                                    <i className='fa fa-rupee'></i>&nbsp;
                                    {Number(countData.total_bounce || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </h4>
                            </div>
                        </div>

                    </div> */}
                    <div className="paymentInsightsMain" style={{ margin: '20px 0px 40px 0px' }}>
                        <div className="paymentOverviewSection outerBoxWithPadding" style={{ padding: '8px' }}>
                            {/* <div className="heading" style={{display:'flex',justifyContent:'space-between'}}>
                                <h4>Overview</h4>
                                <h4 style={{fontSize:'17px'}}>Total Counts (0)</h4>
                            </div> */}
                            <div className="PaymentBoxes">
                                <div className="tabs">
                                    <div className="subtabs" style={{ backgroundColor: '#ffe2e6', height: window.innerWidth < 1200 ? '170px' : '156px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'basline' }}>
                                            <div className="circlesIcon" style={{ backgroundColor: '#fa5a7d' }}><i class="fa fa-cart-arrow-down" aria-hidden="true"></i></div>
                                            <h5 className="bolder-font">{(countData?.paymentCount || 0)?.toLocaleString("en-US")}</h5>

                                        </div>
                                        <h4>{'₹ ' + (Number(countData.paymentAmt || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}</h4>

                                        <h5>Total Amount</h5>
                                        <div style={{ marginTop: '5px', display: 'inline-flex', cursor: 'pointer' }} onClick={() => handleView("overall")}>
                                            {
                                                visible == "overall" ?
                                                    <VisibilityIcon style={{ color: '#267dff' }} />
                                                    :
                                                    <VisibilityOffIcon style={{ color: '#000' }} />
                                            }
                                            <span style={{ fontSize: '12px' }}>&nbsp; {visible == "overall" ? "View Less" : "View More"}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="tabs">
                                    <div className="subtabs" style={{ backgroundColor: '#fff4de', height: window.innerWidth < 1200 ? '170px' : '156px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'basline' }}>
                                            <div className="circlesIcon" style={{ backgroundColor: '#ff947a' }}><i class="fa fa-money" aria-hidden="true"></i></div>
                                            <h5 className="bolder-font">{(countData?.paymentPrincipleCount || 0)?.toLocaleString("en-US")}</h5>

                                        </div>
                                        <h4>{'₹ ' + (Number(countData.paymentPrincipleAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}</h4>

                                        <h5>Principal Amount</h5>
                                    </div>
                                </div>
                                <div className="tabs">
                                    <div className="subtabs" style={{ backgroundColor: '#fff1c1', height: window.innerWidth < 1200 ? '170px' : '156px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'basline' }}>
                                            <div className="circlesIcon" style={{ backgroundColor: '#dbb328' }}><i class="fa fa-money" aria-hidden="true"></i></div>
                                            <h5 className="bolder-font">{(countData?.paymentInterestCount || 0)?.toLocaleString("en-US")}</h5>

                                        </div>
                                        <h4>{'₹ ' + (Number(countData.paymentInterestAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}</h4>

                                        <h5>Interest Amount</h5>
                                    </div>
                                </div>
                                <div className="tabs">
                                    <div className="subtabs" style={{ backgroundColor: '#dcfce7', height: window.innerWidth < 1200 ? '170px' : '156px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'basline' }}>
                                            <div className="circlesIcon" style={{ backgroundColor: '#3dd856' }}><i class="fa fa-credit-card-alt" aria-hidden="true"></i></div>
                                            <h5 className="bolder-font">{(countData?.paymentPenaltyCount || 0)?.toLocaleString("en-US")}</h5>
                                        </div>
                                        <h4>{'₹ ' + (Number(countData.paymentPenaltyAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}</h4>

                                        <h5>Penalty Amount</h5>
                                         <div style={{ marginTop: '5px', display: 'inline-flex', cursor: 'pointer' }} onClick={() => handleView("penality")}>
                                            {
                                                visible == "penality" ?
                                                    <VisibilityIcon style={{ color: '#267dff' }} />
                                                    :
                                                    <VisibilityOffIcon style={{ color: '#000' }} />
                                            }
                                            <span style={{ fontSize: '12px' }}>&nbsp; {visible == "penality" ? "View Less" : "View More"}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="tabs">
                                    <div className="subtabs" style={{ backgroundColor: '#f4e8ff', height: window.innerWidth < 1200 ? '170px' : '156px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'basline' }}>
                                            <div className="circlesIcon" style={{ backgroundColor: '#bf83ff' }}><i class="fa fa-credit-card" aria-hidden="true"></i></div>
                                            <h5 className="bolder-font">{(countData?.paymentPenaltyCountGST)?.toLocaleString("en-US")}</h5>
                                        </div>

                                        <h4>{'₹ ' + (Number(countData.paymentPenaltyAmountGST || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}</h4>

                                        <h5>Penalty GST</h5>
                                    </div>

                                </div>
                                <div className="tabs">
                                    <div className="subtabs" style={{ backgroundColor: '#fdd9fa', height: window.innerWidth < 1200 ? '170px' : '156px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'basline' }}>
                                            <div className="circlesIcon" style={{ backgroundColor: '#f976ee' }}><i class="fa fa-credit-card" aria-hidden="true"></i></div>
                                            <h5 className="bolder-font">{(countData?.paymentBounceCount || 0)?.toLocaleString("en-US")}</h5>
                                        </div>

                                        <h4>{'₹ ' + (Number(countData.paymentBounceAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}</h4>

                                        <h5>Bounce Amount</h5>
                                         <div style={{ marginTop: '5px', display: 'inline-flex', cursor: 'pointer' }} onClick={() => handleView("bounce")}>
                                            {
                                                visible == "bounce" ?
                                                    <VisibilityIcon style={{ color: '#267dff' }} />
                                                    :
                                                    <VisibilityOffIcon style={{ color: '#000' }} />
                                            }
                                            <span style={{ fontSize: '12px' }}>&nbsp; {visible == "bounce" ? "View Less" : "View More"}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>
                </>
            )}

            {filteredData?.length > 0 ? (
                <div className="phocket-table-new">
                    <table style={{ overflowX: 'auto' }}>
                        <thead>
                            <tr>
                                <th className="text-center"><input type="checkbox" onChange={handleSelectAll}
                                    checked={currentItems.every((data) =>
                                        selectedItems.includes(data?.paymentBreakUpDetailsDO?.id)
                                    )}
                                /></th>
                                <th className="text-center">Details</th>
                                <th className="text-center">Refunded</th>
                                <th className="text-center">Application Id</th>
                                <th className="text-center">Transaction Id</th>
                                <th className="text-center">Transaction Amount</th>
                                <th className="text-center">EMI Amount</th>
                                <th className="text-center">Overdue Amount</th>
                                <th className="text-center">OnToday Amount</th>
                                <th className="text-center">Mode</th>
                                <th className="text-center">Channel</th>
                                <th className="text-center">Process Type</th>
                                <th className="text-center" onClick={() => handleAsecFilter(!filterDataDsec)}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        Added On
                                        <div style={{ position: 'relative' }}>
                                            {
                                                filterDataDsec == false ?
                                                    <ArrowDropUpIcon style={{ cursor: 'pointer', position: 'absolute', top: '-10px', fontSize: '20px', zIndex: '2' }} onClick={() => handleAsecFilter(true)} />
                                                    :
                                                    <ArrowDropDownIcon style={{ cursor: 'pointer', position: 'absolute', top: '-10px', fontSize: '20px', zIndex: '2' }} onClick={() => handleAsecFilter(false)} />
                                            }
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems?.map((data, index) => (
                                <tr key={index}>
                                    <td className="text-center"><input type="checkbox" checked={selectedItems.includes(data?.paymentBreakUpDetailsDO?.id)} onChange={(e) => handleCheckbox(e, data)} /></td>
                                    <td className="text-center"><i onClick={() => detailspayment(data)} className="fa fa-info" style={{ cursor: 'pointer' }}></i></td>
                                    <td className="text-center">
                                        <input type="checkbox" checked={data?.payments?.refund == true ? true : false} disabled={data?.payments?.refund == true ? true : false} onChange={(e) => handleRefundCheckbox(e, data)} />
                                    </td>
                                    <td className="text-center">{data?.applicationId}</td>
                                    <td className="text-center">{data?.payments?.providerTransId}</td>
                                    <td className="text-center">{(data?.payments?.amount || 0)?.toLocaleString("en-US")}</td>
                                    <td className="text-center">{(data?.paymentBreakUpDetailsDO?.emiAmount || 0)?.toLocaleString("en-US")}</td>
                                    <td className="text-center">{(data?.paymentBreakUpDetailsDO?.overdueAmount || 0)?.toLocaleString("en-US")}</td>
                                    <td className="text-center">{(data?.paymentBreakUpDetailsDO?.onTodayAmount || 0)?.toLocaleString("en-US")}</td>

                                    <td className="text-center">{data?.payments?.pymntMode}</td>
                                    <td className="text-center">{data?.payments?.addedBy}</td>
                                    <td className="text-center">{data?.payments?.processType}</td>
                                    <td className="text-center">{data?.payments?.addedOn}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div style={{ float: 'right', marginTop: '15px' }}>
                        <Pagination
                            count={Math.ceil(filteredData?.length / itemsPerPage)}
                            page={currentPage}
                            onChange={handlePageChange}
                            color="success"
                        />
                    </div>
                    {
                        newValues?.length > 0 ?
                            <div style={{ margin: '80px 0px 20px 0px', textAlign: 'center' }}>
                                <button style={{ background: '#006c67', color: '#fff', padding: '10px', borderRadius: '8px' }} onClick={() => handleVerifyPayments()}>Verify Payments</button>
                            </div>
                            : ''}
                </div>
            ) : (
                <p style={{ marginTop: '100px' }} className="text-center">
                    <img src={NodataImage} style={{ width: '30%' }} />
                </p>
            )}
        </div>
    );
};

export default Allpayments;
